import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private SERVER_URL1 = environment.apiUrl1;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Ocp-Apim-Subscription-Key': environment.apiSubscription.OcpApimSubscriptionKey,
      'Ocp-Apim-Trace': 'true',
      'Api-Version': '1.0',
    }),
  };

  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  public AuthenticateUser(guid: string): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/Auth/${guid}`, this.httpOptions).pipe(map( data => data));
  }

  public getAutos(rut: string): Observable<any> {
    return this.httpClient.get(`${this.SERVER_URL1}/MiSeguro/autolist/${rut}`, this.httpOptions).pipe(map( data => data));
  }

  public getMiSeguro(rut: string, idPoliza: string): Observable<any>{
    console.log('el valor de patente es: ', idPoliza);
    return this.httpClient.get(`${this.SERVER_URL1}/MiSeguro/${rut}/${idPoliza}`, this.httpOptions).pipe(map( data => data));
  }
  public ObtainTravelsMonthData(rut: string, idVoucher: string): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/MisViajes/months/${rut}/${idVoucher}`, this.httpOptions).pipe(map( data => data));
  }
  public ObtainTravelsDayData(idVoucher: string, day: string, month: string, year: string,valorKm: number): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/MisViajes/trips/${idVoucher}/${day}/${month}/${year}/${valorKm}`, this.httpOptions).pipe(map( data => data));
  }
  public ObtainRouteCoordinatesList(idTrip: number): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/MisViajes/tripDetails/${idTrip}`, this.httpOptions).pipe(map( data => data));
  }
  public ObtainDataCar(idVoucher: string): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/MiSeguro/GetDataCar/${idVoucher}`, this.httpOptions).pipe(map( data => data));
  }
  public ObtainDataMyEvents(idVoucher: string, initDate: Date, endDate: Date): Observable<any>{
    return this.httpClient.get(`${this.SERVER_URL1}/MisEventos/${idVoucher}/${initDate.getDate()}/${initDate.getMonth() + 1}/${initDate.getFullYear()}/${endDate.getDate()}/${endDate.getMonth() + 1}/${endDate.getFullYear()}`, this.httpOptions).pipe(map( data => data));
  }
}
